import { ComboboxOption } from 'ui';

// Ids not among the options yet (e.g. read from the URL) fall back to the raw id.
export const mapIdsToOptions = <Value extends string>(
  ids: Value[],
  options: ComboboxOption<Value>[],
): ComboboxOption<Value>[] =>
  ids.map(
    (id) =>
      options.find((option) => option.value === id) ?? { label: id, value: id },
  );
